module.exports = __webpack_public_path__ + "img/4-2_Sample_DataView_3.8da6c416.png";